module.exports = __webpack_public_path__ + "img/blue-x.1393643a.svg";